import { render, staticRenderFns } from "./dataRecord.vue?vue&type=template&id=433b5d5e&"
import script from "./dataRecord.vue?vue&type=script&lang=js&"
export * from "./dataRecord.vue?vue&type=script&lang=js&"
import style0 from "./dataRecord.vue?vue&type=style&index=0&id=433b5d5e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports